export default __webpack_public_path__ + "media/auther_name.060fde3c.png";